'use client';import*as React from'react';import createSvgIcon from'../../utils/createSvgIcon';/**
 * @ignore - internal component.
 */import{jsx as _jsx}from"react/jsx-runtime";export default createSvgIcon(/*#__PURE__*/_jsx("path",{d:"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}),'NavigateBefore');